module.exports = __webpack_public_path__ + "static/media/undraw_design_team_af2y.4d784698.svg";